// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aucm4e0 {
  font-size: 20px;
  line-height: 1.25;
  margin-top: 12px;
  font-weight: var(--_18w76bw3w);
}
@media screen and (min-width: 768px) {
  .aucm4e0 {
    font-size: 36px;
    line-height: 1.66667;
    margin-top: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE;IACE,eAAe;IACf,oBAAoB;IACpB,gBAAgB;EAClB;AACF","sourcesContent":[".aucm4e0 {\n  font-size: 20px;\n  line-height: 1.25;\n  margin-top: 12px;\n  font-weight: var(--_18w76bw3w);\n}\n@media screen and (min-width: 768px) {\n  .aucm4e0 {\n    font-size: 36px;\n    line-height: 1.66667;\n    margin-top: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
